import React, { useCallback, useState } from "react";
import { createStyles, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import Brands from "../../Brands";
import { trackMainNavEvent } from "../../analytics";
var useStyles = makeStyles(function () {
    return createStyles({
        wrapper: {
            display: "grid",
            gridAutoFlow: "column",
            gridGap: "24px",
            height: "40px",
            padding: 0,
        },
        item: {
            display: "flex",
            alignItems: "center",
            height: 40,
            fontSize: 0,
            color: "#fff",
            cursor: "pointer",
            userSelect: "none",
        },
        link: {
            display: "inline-block",
            fontSize: "14px",
            lineHeight: "40px",
            letterSpacing: 0.3,
            outline: "none",
            "&:hover, &:focus, &.active": {
                fontWeight: "bold",
                letterSpacing: "normal",
                textShadow: "0 0 #fff",
                WebkitFontSmoothing: "subpixel-antialiased",
            },
            "&::before": {
                display: "block",
                content: "attr(data-title)",
                visibility: "hidden",
                overflow: "hidden",
                height: 0,
                fontWeight: "bold",
                letterSpacing: 0.3,
            },
        },
    });
});
var Divisions = function (_a) {
    var divisions = _a.divisions, ourBrands = _a.ourBrands;
    var styles = useStyles();
    var _b = useState(false), showBrands = _b[0], setShowBrands = _b[1];
    var handleClose = function () { return setShowBrands(false); };
    var handleClick = useCallback(function (event) {
        event.preventDefault();
        setShowBrands(true);
        trackMainNavEvent(ourBrands.name);
    }, [ourBrands.name]);
    var boldIndex = divisions.findIndex(function (item) { return item.regex && RegExp(item.regex, "i").test(window.location.href); });
    if (boldIndex < 0)
        boldIndex = 0;
    return (React.createElement("nav", null,
        React.createElement("ul", { className: styles.wrapper },
            divisions.map(function (_a, index) {
                var name = _a.name, url = _a.url;
                return (React.createElement("li", { key: index, className: styles.item },
                    React.createElement("a", { id: "headerNavigation" + name.replace(/\s*\W*/g, ""), href: url, className: clsx(styles.link, { active: index === boldIndex }), onClick: function () { return trackMainNavEvent(name, url); }, "data-title": name }, name)));
            }),
            React.createElement("li", { className: styles.item },
                React.createElement("a", { id: "headerCrossPromo", href: "#", className: styles.link, onClick: handleClick, "data-title": ourBrands.name }, ourBrands.name)),
            showBrands && React.createElement(Brands, { open: showBrands, onClose: handleClose }))));
};
export default Divisions;
